import request from '@/axios/index.js'
const sign = '/review/gold/sign/'
const gold = '/review/gold/'
const modified = '/review/gold/modified/'
const pay = '/review/gold/pay/'
const finance = '/review/finance/'
const guarantee = "/review/gold/guarantee/"
export function signPage(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: sign + 'page'
    })
}
export function guaranteePage(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: guarantee + 'page'
    })
}
export function ReviewBillIssueApi(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: gold + 'sign'
    })
}
export function Reviewguarantee(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: gold + 'guaranteeReview'
    })
}
// 查看转让协议
export function queryGoldguaranteeContract(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: '/goldenTicketLawTxtPreview/guarantee'
    })
}
export function findSignReviewRcptyOrManager(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: sign + 'findSignReviewRcptyOrManager'
    })
}
export function findGuaranteeReviewRcptyOrManager(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: sign + 'findGuaranteeReviewRcptyOrManager'
    })
}
export function modifiedPage(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: modified + 'page'
    })
}
export function findModifiedReviewRcptyOrManager(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: modified + 'findModifiedReviewRcptyOrManager'
    })
}
export function ReviewExdatechangeApi(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: modified
    })
}
export function payPageApi(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: pay + "page"
    })
}
export function findPayReviewEstbOrRcptyOrManager(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: pay + "findPayReviewEstbOrRcptyOrManager"
    })
}
export function financePageApi(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: finance + "page"
    })
}
export function findFinanceReviewEstbOrRcptyOrManager(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: finance + "findPayReviewEstbOrRcptyOrManager"
    })
}

export function ReviewFinancingApi(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: finance
    })
}
// 支付复核
export function reviewPay(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: '/review/gold/pay'
    })
}
// 兑付复核列表
export function reviewPayVoucherList(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: '/pay/reviewPayVoucherList'
    })
}
// 兑付复核
export function reviewPayVoucherSubmit(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: '/pay/reviewPayVoucherSubmit'
    })
}
// 兑付经办员查询下拉列表

export function handelUserList(data, loading) {
    return request.axios({
        loading: loading,
        data: data,
        url: '/pay/handelUserList'
    })
}



// WEBPACK FOOTER //
// ./src/api/review.js